import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import Layout from './Layout';

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Check if user is already authenticated
    fetch('/api/auth/status', { credentials: 'include' })
      .then(res => res.json())
      .then(data => {
        if (data.authenticated && data.user?.isAdmin) {
          navigate('/admin');
        }
      })
      .catch(console.error);

    // Check for error in URL params
    const errorParam = searchParams.get('error');
    if (errorParam === 'access_denied') {
      setError('access_denied');
    }
  }, [navigate, searchParams]);

  const handleGoogleLogin = () => {
    setLoading(true);
    setError('');

    // Redirect to Google OAuth
    window.location.href = '/api/auth/google';
  };


  return (
    <Layout>
      <div className="container" style={{ marginTop: '120px', minHeight: 'calc(100vh - 300px)' }}>
        <div className="card text-center" style={{ maxWidth: '500px', margin: '0 auto', padding: '2rem' }}>
          <div className="section-header">
            <h1 className="section-title lithuanian-heading"> Administratoriaus prisijungimas</h1>
            <p className="section-subtitle lithuanian-text">
              Prisijunkite su Google paskyra, kad pasiektumėte administracijos panelę
            </p>
          </div>

          {error === 'access_denied' && (
            <div style={{
              backgroundColor: '#fee',
              border: '2px solid #c33',
              borderRadius: '8px',
              padding: '1.5rem',
              marginBottom: '1.5rem',
              textAlign: 'left'
            }}>
              <div style={{
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#c33',
                marginBottom: '0.75rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}>
                🚫 Prieiga uždrausta
              </div>
              <p style={{ margin: '0.5rem 0', color: '#333', lineHeight: '1.6' }}>
                Bandėte prisijungti su Google paskyra, kuri neturi administratoriaus teisių.
              </p>
              <p style={{ margin: '0.5rem 0', color: '#333', lineHeight: '1.6' }}>
                <strong>Tik šis el. paštas gali prisijungti:</strong> atsiliepsiu@gmail.com
              </p>
              <p style={{ margin: '0.5rem 0', fontSize: '0.9rem', color: '#666', lineHeight: '1.6' }}>
                Jei manote, kad tai klaida, kreipkitės į sistemos administratorių.
              </p>
            </div>
          )}

          {error && error !== 'access_denied' && (
            <div className="error-message">
              {error}
            </div>
          )}

          <form style={{ marginBottom: '2rem' }}>
            <button
              type="button"
              onClick={handleGoogleLogin}
              disabled={loading}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.75rem',
                margin: '0 auto',
                background: '#4285F4',
                color: 'white',
                border: '2px solid #4285F4',
                borderRadius: '4px',
                padding: '1rem 2rem',
                fontSize: '16px',
                fontWeight: '600',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'all 0.3s ease',
                opacity: loading ? 0.7 : 1
              }}
              onMouseOver={(e) => {
                if (!loading) {
                  e.target.style.background = '#3367D6';
                  e.target.style.borderColor = '#3367D6';
                }
              }}
              onMouseOut={(e) => {
                if (!loading) {
                  e.target.style.background = '#4285F4';
                  e.target.style.borderColor = '#4285F4';
                }
              }}
            >
              {loading ? (
                <>
                  <div style={{
                    width: '20px',
                    height: '20px',
                    border: '2px solid #f3f3f3',
                    borderTop: '2px solid var(--primary-navy)',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                  Jungiamasi...
                </>
              ) : (
                <>
                  <svg width="20" height="20" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                  Prisijungti su Google
                </>
              )}
            </button>

            <div className="auth-links" style={{ marginTop: '1.5rem' }}>
              <Link to="/" className="link-button">
                ← Grįžti į pagrindinį puslapį
              </Link>
            </div>
          </form>
        </div>

      </div>
    </Layout>
  );
};

export default AdminLogin;